module.exports = __webpack_public_path__ + "static/img/bg4.9ec81f7f.jpg";